
import Vue, { PropType } from 'vue'
import { AlertDestination } from '@/models'
import BaseDropDown, { OptionItem } from '@/components/BaseDropDown.vue'

export type DataType = {
  options: OptionItem[];
  showing: boolean;
}

export default Vue.extend({
  name: 'AlertDestinationListItem',

  components: {
    BaseDropDown
  },

  props: {
    alertDestination: Object as PropType<AlertDestination>
  },

  data(): DataType {
    return {
      options: [
        {
          label: '通知先を編集',
          classes: ['dropdown-item-default'],
          clickAction: () => {
            this.$router.push({
              name: 'company-alert-destination-detail',
              params: {
                alertDestinationId: this.alertDestination.id as string
              }
            })
          }
        },
        {
          label: '通知先を削除',
          classes: ['red'],
          clickAction: () => {
            this.$router.push({
              name: 'company-alert-destination-delete',
              params: {
                alertDestinationId: this.alertDestination.id as string
              }
            })
          }
        }
      ],
      showing: false
    }
  },

  computed: {
    editMenuClassText(): string {
      return this.showing ? 'active' : ''
    }
  }
})
